import React, { FC, useCallback } from 'react'
import styles from 'styles/components/template.module.scss'
import { State } from 'index'
import { push } from 'connected-react-router'
import { useDispatch, useSelector } from 'react-redux'
import { Spacer } from 'components/Utility'
import { GreyButton, OrangeButton } from 'components/Button'
import { MainHeadline } from 'components/Typography'
import { AlertCard, TransferCard } from 'components/Card'
import { getStoreRef } from 'reducks/auth/selectors'
import { calcTransferFee } from 'lib/revenue'
import { useRefreshByIdleTime } from 'hooks/utility'
import { useQueryShopBalance, useRequestTransfer } from 'hooks/revenue'
import { MIN_TRANSFERABLE_AMOUNT } from 'constants/stripe'
import { getShopRef } from 'reducks/store/selectors'

const BankTransferTemplate: FC = () => {
  const dispatch = useDispatch()
  const storeRef = useSelector((state: State) => getStoreRef(state))
  const shopRef = useSelector((state: State) => getShopRef(state))
  const query = useSelector((state: State) => state.router.location.query)
  const partialAmount: string | undefined = query.amount
  const balance = useQueryShopBalance(shopRef?.id)
  const { availableAmount } = balance
  const transferAmount = partialAmount ? parseInt(partialAmount, 10) : availableAmount
  const transferFee = calcTransferFee(transferAmount)
  const finalTransferAmount = transferAmount - transferFee
  const requestTransfer = useRequestTransfer(transferAmount, storeRef.id)
  const isAbleToTransfer = transferAmount > MIN_TRANSFERABLE_AMOUNT && availableAmount >= transferAmount
  const backToBalance = useCallback(() => dispatch(push('/account/revenue/balance')), [])
  // 5分間操作がなければリロード
  useRefreshByIdleTime(300)
  return (
    <div className={styles.standard}>
      <Spacer size={28} />
      <MainHeadline headline={'入金金額の確認'} />
      <Spacer size={28} />
      <AlertCard
        description={'必ず明細を確認のうえ、振り込みを行うボタンを押してください。'}
        headline={'一度受け付けた入金処理は取り消すことができません'}
        title={'注意'}
      />
      <Spacer size={72} />
      <TransferCard
        transferAmount={transferAmount}
        transferFee={transferFee}
        finalTransferAmount={finalTransferAmount}
      />
      <Spacer size={48} />
      <OrangeButton
        disabled={!isAbleToTransfer}
        label={'振り込みを行う'}
        onClick={requestTransfer}
        size={'medium'}
        type={'main'}
      />
      <Spacer size={48} />
      <GreyButton label={'入金可能残高ページに戻る'} onClick={backToBalance} size={'medium'} type={'outlined'} />
      <Spacer size={72} />
    </div>
  )
}

export default BankTransferTemplate
